import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { Button, Typography } from "@mui/material";

import { useDialog } from "../../../../../common/components/dialog/useDialog";
import { useGetLazyPaginatedSKUs } from "../hooks/useGetLazyPaginatedSKUs";
import CreateSKUDialog from "./CreateSKUDialog";

const CreateSKUDialogContainer = (): JSX.Element => {
  const { open, handleDialogOpen, handleDialogClose } = useDialog();
  const { data } = useGetLazyPaginatedSKUs();

  const existingConfigurationNames =
    data?.getSKUs?.items
      .map(item => item?.configurationName)
      .filter((name): name is string => Boolean(name)) ?? [];

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<AddOutlinedIcon />}
        onClick={handleDialogOpen}
      >
        <Typography variant="buttonMedium">Create System Template</Typography>
      </Button>

      {open && (
        <CreateSKUDialog
          open={open}
          handleClose={handleDialogClose}
          existingConfigurationNames={existingConfigurationNames}
        />
      )}
    </>
  );
};

export default CreateSKUDialogContainer;
